module.exports = __webpack_public_path__ + "media/images/top/guide-icon-080605a7197c337a21d1ae009500b47a.png";